export const THUMBNAIL_LIST_RESET = 'THUMBNAIL_LIST_RESET'
export const THUMBNAIL_LIST_SET_ERROR = 'THUMBNAIL_LIST_SET_ERROR'
export const THUMBNAIL_LIST_SET_ITEMS = 'THUMBNAIL_LIST_SET_ITEMS'
export const THUMBNAIL_LIST_SET_VIEW = 'THUMBNAIL_LIST_SET_VIEW'
export const THUMBNAIL_LIST_SET_TOTAL_ITEMS = 'THUMBNAIL_LIST_SET_TOTAL_ITEMS'
export const THUMBNAIL_LIST_SET_LOADING = 'THUMBNAIL_LIST_SET_LOADING'
